module.exports = __webpack_public_path__ + "media/images/icons/tag-33cbe3dbb3212966da8c773e05b10e3c.svg";